import ClubBookedSalesListOfferingItem from '../ClubBookedSalesListOfferingItem.js';
import Member from '../Member.js';

export default class OfferingBooking {
    static fromData(data) {
        if (!data) {
            return;
        }

        const offeringBooking = new OfferingBooking();

        offeringBooking.id = data.id || null;
        offeringBooking.bookedAt = data.bookedAt;
        offeringBooking.canceledAt = data.canceledAt;
        offeringBooking.canceledByClubAt = data.canceledByClubAt;
        offeringBooking.isCanceled = data.isCanceled;
        offeringBooking.member = Member.fromData(data.member);
        offeringBooking.bookedByClub = data.bookedByClub;
        offeringBooking.comment = data.comment;
        offeringBooking.attendeeStatus = data.attendeeStatus;
        offeringBooking.checked = false;
        offeringBooking.canViewShortProfile = data.canViewShortProfile;
        offeringBooking.canAcceptOrReject = data.canAcceptOrReject;
        offeringBooking.isEditable = data.isEditable || false;
        if (data.selectedClubExams) {
            offeringBooking.selectedClubExams = data.selectedClubExams;
        }
        if (data.dog) {
            offeringBooking.dog = data.dog;
        }
        if (data.bookedSalesListOfferingItems) {
            offeringBooking.bookedSalesListOfferingItems = data.bookedSalesListOfferingItems.map((bookedOfferingItem) => ClubBookedSalesListOfferingItem.fromData(bookedOfferingItem));
        }

        return offeringBooking;
    }
}
